"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSupplyStatusList = void 0;
const Base_1 = require("./Base");
exports.GetSupplyStatusList = {
    url: Base_1.URL_BASE + "/GetSupplyStatusList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSupplyStatusList.js.map